import { Checkbox } from '@catering/ui';
import type { JSX } from 'react';

import type { OperatingUnitOption } from '../../../../operating-units/operating-units-api';

export interface OperatingUnitsFieldsetProps {
  options: OperatingUnitOption[];
  selectedIds: string[];
  onToggle: (id: string) => void;
}

/** Multi-select of points of sale; none selected means every point (`internal-users/spec.md`). */
export function OperatingUnitsFieldset({
  options,
  selectedIds,
  onToggle,
}: OperatingUnitsFieldsetProps): JSX.Element | null {
  if (options.length === 0) {
    return null;
  }

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="text-sm font-medium text-slate-900">Puntos de venta</legend>
      {options.map((option) => (
        <Checkbox
          key={option.id}
          label={option.name}
          checked={selectedIds.includes(option.id)}
          onChange={() => onToggle(option.id)}
        />
      ))}
      <p className="text-xs text-slate-500">Si no marcás ninguno, trabaja con todos los puntos.</p>
    </fieldset>
  );
}
